export const environment = {
  production: false,
  host: "https://forhandlerportal.test.micar.dk",
  port: "443",
  hotjarId: "6452232", // Staging Hotjar ID (same as production for now)
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts